import React, { useState } from 'react';
import './style.css'
import TransliterationObjet from './TransliterationObjet';

const Transcriptor = () => {
    const [resultTextSimple, setResultTextSimple] = useState("");
    const [resultTextComplet, setResultTextComplet] = useState("");
    const [inputText, setInputText] = useState("");

    const TRANSCRIPTION_TYPES = {
        SIMPLE : new TransliterationObjet({
            id : "SIMPLE",
            name : "Simple",

            // ===== Harakaats =====
            tanwiinats : {
                "ً": { marker: "{an}", value: "an" },
                "ٍ": { marker: "{in}", value: "in" },
                "ٌ": { marker: "{un}", value: "un" },
            },
            hurufou_madd : {
                "{ii}": { marker: "{ii}", value: "ii" },
                "{uu}": { marker: "{uu}", value: "uu" },
                "{aa}": { marker: "{aa}", value: "aa" },
            },
            harakaats : {
                "ِ": { marker: "{i}", value: "i" },
                "ُ": { marker: "{u}", value: "u" },
                "َ": { marker: "{a}", value: "a" },
                "ْ": { marker: "{sukun}", value: "" },
                "ّ": { marker: "{sadda}", value: "" },
            },

            // ===== Lettres solaires =====
            hurufou_chamsiya : {
                "ت": { marker: "{ta}", value: "t" },
                "ة": { marker: "{ta}", value: "t" },
                "ث": { marker: "{tha}", value: "s" },
                "د": { marker: "{dal}", value: "d" },
                "ذ": { marker: "{dhal}", value: "z" },
                "ر": { marker: "{ra}", value: "r" },
                "ز": { marker: "{zai}", value: "z" },
                "س": { marker: "{sin}", value: "s" },
                "ش": { marker: "{shin}", value: "ch" },
                "ص": { marker: "{soad}", value: "s" },
                "ض": { marker: "{doad}", value: "d" },
                "ط": { marker: "{toa}", value: "t" },
                "ظ": { marker: "{zoa}", value: "z" },
                "ل": { marker: "{lam}", value: "l" },
                "ﻟ": { marker: "{lam}", value: "l" },
                "ن": { marker: "{nun}", value: "n" },
            },

            // ===== Lettres lunaires =====
            hurufou_qamariya : {
                "ا": { marker: "{alif}", value: "" },
                "ٱ": { marker: "{alif}", value: "" },
                "ٰ": { marker: "{alif}", value: "" }, // Alif khanjariyya
                "{hamza}": { marker: "{hamza}", value: "-" },
                "ب": { marker: "{ba}", value: "b" },
                "ج": { marker: "{jim}", value: "j" },
                "ح": { marker: "{ḥa}", value: "ɦ" },
                "خ": { marker: "{kha}", value: "kh" },
                "ع": { marker: "{ain}", value: "'" },
                "غ": { marker: "{ghain}", value: "gh" },
                "ف": { marker: "{fa}", value: "f" },
                "ﻓ": { marker: "{fa}", value: "f" },
                "ق": { marker: "{qaf}", value: "q" },
                "ك": { marker: "{kaf}", value: "k" },
                "ک": { marker: "{kaf}", value: "k" },
                "م": { marker: "{mim}", value: "m" },
                "ه": { marker: "{ha}", value: "h" },
                "ھ": { marker: "{ha}", value: "h" },
                "و": { marker: "{waw}", value: "w" },
                "ي": { marker: "{ya}", value: "y" },
                "ی": { marker: "{ya}", value: "y" },
                "ﻳ": { marker: "{ya}", value: "y" },
                "ﯿ": { marker: "{ya}", value: "y" },
            },

            no_duplicables : {
                "ش": { marker: "{shin}", value: "ch" },
                "خ": { marker: "{kha}", value: "kh" },
                "ع": { marker: "{ain}", value: "'" },
                "غ": { marker: "{ghain}", value: "gh" },
            },
        }),
        COMPLET : new TransliterationObjet({
            id : "COMPLET",
            name : "Complet",

            // ===== Harakaats =====
            tanwiinats : {
                "ً": { marker: "{an}", value: "an" },
                "ٍ": { marker: "{in}", value: "in" },
                "ٌ": { marker: "{un}", value: "un" },
            },
            hurufou_madd : {
                "{ii}": { marker: "{ii}", value: "ī" },
                "{uu}": { marker: "{uu}", value: "ū" },
                "{aa}": { marker: "{aa}", value: "ā" },
            },
            harakaats : {
                "ِ": { marker: "{i}", value: "i" },
                "ُ": { marker: "{u}", value: "u" },
                "َ": { marker: "{a}", value: "a" },
                "ْ": { marker: "{sukun}", value: "" },
                "ّ": { marker: "{sadda}", value: "" },
            },

            // ===== Lettres solaires =====
            hurufou_chamsiya : {
                "ت": { marker: "{ta}", value: "t" },
                "ة": { marker: "{ta}", value: "t" },
                "ث": { marker: "{tha}", value: "th" },
                "د": { marker: "{dal}", value: "d" },
                "ذ": { marker: "{dhal}", value: "dh" },
                "ر": { marker: "{ra}", value: "r" },
                "ز": { marker: "{zai}", value: "z" },
                "س": { marker: "{sin}", value: "s" },
                "ش": { marker: "{shin}", value: "sh" },
                "ص": { marker: "{soad}", value: "ṣ" },
                "ض": { marker: "{doad}", value: "ḍ" },
                "ط": { marker: "{toa}", value: "ṭ" },
                "ظ": { marker: "{zoa}", value: "ẓ" },
                "ل": { marker: "{lam}", value: "l" },
                "ﻟ": { marker: "{lam}", value: "l" },
                "ن": { marker: "{nun}", value: "n" },
            },

            // ===== Lettres lunaires =====
            hurufou_qamariya : {
                "ا": { marker: "{alif}", value: "" },
                "ٱ": { marker: "{alif}", value: "" },
                "ٰ": { marker: "{alif}", value: "" }, // Alif khanjariyya
                "{hamza}": { marker: "{hamza}", value: "-" },
                "ب": { marker: "{ba}", value: "b" },
                "ج": { marker: "{jim}", value: "j" },
                "ح": { marker: "{ḥa}", value: "ḥ" },
                "خ": { marker: "{kha}", value: "kh" },
                "ع": { marker: "{ain}", value: "ʿ" },
                "غ": { marker: "{ghain}", value: "gh" },
                "ف": { marker: "{fa}", value: "f" },
                "ﻓ": { marker: "{fa}", value: "f" },
                "ق": { marker: "{qaf}", value: "q" },
                "ك": { marker: "{kaf}", value: "k" },
                "ک": { marker: "{kaf}", value: "k" },
                "م": { marker: "{mim}", value: "m" },
                "ه": { marker: "{ha}", value: "h" },
                "ھ": { marker: "{ha}", value: "h" },
                "و": { marker: "{waw}", value: "w" },
                "ي": { marker: "{ya}", value: "y" },
                "ی": { marker: "{ya}", value: "y" },
                "ﻳ": { marker: "{ya}", value: "y" },
                "ﯿ": { marker: "{ya}", value: "y" },
            },

            no_duplicables : {
                "ث": { marker: "{tha}", value: "th" },
                "ذ": { marker: "{dhal}", value: "dh" },
                "ش": { marker: "{shin}", value: "sh" },
                "خ": { marker: "{kha}", value: "kh" },
                "ع": { marker: "{ain}", value: "ʿ" },
                "غ": { marker: "{ghain}", value: "gh" },
            },
        }),
    }
    const [currentType, setCurrentType] = useState(TRANSCRIPTION_TYPES.SIMPLE);

    function escapeRegExp(str) {
        return str.replace(/[{}]/g, "\\$&");
    }

    const addMarkers = (text, currentType=TRANSCRIPTION_TYPES.SIMPLE) => {
        // Gérer les cas spéciaux
        // text = text.replace(/الله/g, "الْلَاه"); // Allah
        // text = text.replace(/(للّهِ|لِلَّهِ)/g, "لِلْلَاهِ"); // lillahi
        text = text.replaceAll("ـ", ""); 
        text = text.replace(/آ|آ/g, "{hamza}{aa}"); 
        text = text.replaceAll("َى", "{aa}"); 
        text = text.replaceAll("لاَ", "لَا"); 
        // Hamza
        text = text.replace(/[ىأإءؤئ]/g, "{hamza}");

        // ajouter tous les marqueurs
        // ===== Toutes les lettres =====
        const all_letters = {
            // Lettres solaires
            ...currentType.hurufou_chamsiya,
            // Lettres lunaires
            ...currentType.hurufou_qamariya,
            // Harakaats
            ...currentType.getAllHarakaats()
        };

        Object.entries(all_letters).forEach(([k,{marker,value}]) => {
            text = text.replaceAll(k, marker);
        });


        // حروف المد
        text = text.replace(new RegExp(escapeRegExp("({a}){alif}(?!({a}|{i}|{u}|{an}|{in}|{un}|{aa}|{ii}|{uu}|{sukun}|{sadda}))"),"g"), "{aa}");
        text = text.replace(new RegExp(escapeRegExp("(({a}{sadda})|({sadda}{a})){alif}(?!({a}|{i}|{u}|{an}|{in}|{un}|{aa}|{ii}|{uu}|{sukun}|{sadda}))"),"g"), "{sadda}{aa}");
        text = text.replace(new RegExp(escapeRegExp("({i}){ya}(?!({a}|{i}|{u}|{an}|{in}|{un}|{aa}|{ii}|{uu}|{sukun}|{sadda}))"),"g"), "{ii}");
        text = text.replace(new RegExp(escapeRegExp("(({i}{sadda})|({sadda}{i})){ya}(?!({a}|{i}|{u}|{an}|{in}|{un}|{aa}|{ii}|{uu}|{sukun}|{sadda}))"),"g"), "{sadda}{ii}");
        text = text.replace(new RegExp(escapeRegExp("({u}){waw}(?!({a}|{i}|{u}|{an}|{in}|{un}|{aa}|{ii}|{uu}|{sukun}|{sadda}))"),"g"), "{uu}");
        text = text.replace(new RegExp(escapeRegExp("(({u}{sadda})|({sadda}{u})){waw}(?!({a}|{i}|{u}|{an}|{in}|{un}|{aa}|{ii}|{uu}|{sukun}|{sadda}))"),"g"), "{sadda}{uu}");

        text = text.replace(new RegExp( // Lillahi
            escapeRegExp("((\\s|\\n)({lam})({i})?({lam})({a})?({sadda})?({a})?({ha})({i})?)"),"g"),
            " {lam}{i}{lam}{sadda}{aa}{ha}{i}"
        );
        text = text.replace(new RegExp( // Allah au debut
            escapeRegExp("(^{alif}?|\\n{alif})({lam})({a})?({sadda})?({a})?({lam})({a})?({sadda})?({a})?({alif})?({ha})"),"g"),
            "{a}{lam}{sadda}{aa}{ha}"
        );
        text = text.replace(new RegExp( // Allah
            escapeRegExp("({alif})?({lam})({a})?({sadda})?({a})?({lam})({a})?({sadda})?({a})?({alif})?({ha})"),"g"),
            "{alif}{lam}{sadda}{aa}{ha}"
        );

        return text;
    }
    const retireMarkers = (text, all_letters) => {
        Object.entries(all_letters).forEach(([key, {marker,value}]) => {
            text = text.replace(
                new RegExp(escapeRegExp(marker), "g"),
                value
            );
        });
        return text;
    }
    const treateTranscriptions = (text, currentType=TRANSCRIPTION_TYPES.SIMPLE)=> {

        // Restaurer les marqueurs
        text = text.replace(/^\{hamza\}/, "");

        
        // ===== Toutes les lettres =====
        const all_letters = currentType.getAllLetters();

        // ===== Gestion des cas spéciaux =====

        Object.values(all_letters).forEach(({marker:letter}) => {

            Object.values(currentType.getAllHarakaats()).forEach(({marker:haraka}) => {

                // Lettres solaires
                if (Object.values(currentType.hurufou_chamsiya).map(v => v.marker).includes(letter)) {

                    // début de phrase
                    text = text.replace(
                        new RegExp(escapeRegExp(`\\n{alif}{lam}${letter}((${haraka}{sadda})|({sadda}${haraka}))` ), "g"),
                        `a${letter}-${letter}${haraka}`
                    );
                    // milieu
                    text = text.replace(
                        new RegExp(escapeRegExp(`\\s{alif}{lam}${letter}((${haraka}{sadda})|({sadda}${haraka}))`), "g"),
                        `${letter} ${letter}${haraka}`
                    );
                    text = text.replace(// لِلصُّدُورْ كَالنَّدِّ بِالدّينِ وَالدَّاء
                        new RegExp(escapeRegExp(`(({alif})?)(\\s)?{lam}${letter}((${letter}${haraka})|(${haraka}{sadda})|({sadda}${haraka}))`), "g"),
                        `${letter} ${letter}${haraka}`
                    );
                }
                // Lettres lunaires
                if (Object.values(currentType.hurufou_qamariya).map(v => v.marker).includes(letter)) {

                    // لِلْعَاشِقِينَ
                    text = text.replace(
                        new RegExp(escapeRegExp(`(\\n|\\s){lam}{i}{lam}{sukun}${letter}` ), "g"),
                        ` {lam}{i}{lam}{sukun} ${letter}`
                    );
                }
                text = text.replace(// مِنْ مَّاءِ
                    new RegExp(escapeRegExp(`\\s${letter}((${haraka}{sadda})|({sadda}${haraka}))`), "g"),
                    ` ${letter}${haraka}`
                );

                // Gestion du shadda
                text = text.replace(
                    new RegExp(escapeRegExp(`${letter}((${haraka}{sadda})|({sadda}${haraka}))`),"g"),
                    `${letter}${letter}${haraka}`
                );
            });
            Object.values(currentType.tanwiinats).map(v => v.marker).forEach(tanwin => {
                text = text.replace( // وَلِشِعْرٍ الْمَفَرْ
                    new RegExp(escapeRegExp(`(${tanwin}){lam}`), "g"),
                    `${tanwin}{i}{lam}`
                );
                text = text.replace( // hudan-
                    new RegExp(escapeRegExp(`${tanwin}{hamza}\\s`), "g"),
                    `${tanwin} `
                );
            })

            // Gestion de "al"
            text = text.replace(
                new RegExp(escapeRegExp(`\\n{alif}{lam}({sukun})?${letter}`), "g"),
                `\n{a}{lam}-${letter}`
            );
            text = text.replace(
                new RegExp(escapeRegExp(`\\s{alif}{lam}({sukun})?${letter}`), "g"),
                `l ${letter}`
            );
            // al-jūdu
            text = text.replace( // 
                new RegExp(escapeRegExp(`\\n{alif}${letter}{sukun}`), "g"),
                `\n{a}${letter}-`
            );
            text = text.replace( // 
                new RegExp(escapeRegExp(`\\s{alif}${letter}{sukun}`), "g"),
                `${letter} `
            );

            // ===== Quelques arrangements pour la lisiblite =====
            Object.values(currentType.hurufou_madd).forEach(({marker:madd},index) => {
                text = text.replace(// diini waad dunyaa
                    new RegExp(escapeRegExp(`${madd}${letter}\\s${letter}`),"g"),
                    `${Object.values(currentType.harakaats)[index].marker}${letter} ${letter}`
                );
                ["{fa}","{kaf}","{waw}","{lam}","{ba}"].forEach(prefix => {
                    text = text.replace(// falkaa-inaatu
                        new RegExp(escapeRegExp(`\\s${prefix}${madd}{lam}({sukun})?${letter}`),"g"),
                        ` ${prefix}${Object.values(currentType.harakaats)[index].marker}{lam} ${letter}`
                    );
                });
                ["{waw}","{lam}","{ba}","{kaf}"].forEach(prefix => {
                    text = text.replace(// وَاسْمُ
                        new RegExp(escapeRegExp(`\\s${prefix}${madd}${letter}{sukun}`),"g"),
                        ` ${prefix}${Object.values(currentType.harakaats)[index].marker}${letter}{sukun}`
                    );
                });

                text = text.replace(new RegExp( // ilaal hudaa, fiil 
                    escapeRegExp(`${madd}\\s{alif}{lam}{sukun}`),"g"),
                    `${Object.values(currentType.harakaats)[index].marker} {alif}{lam}{sukun}`,
                );

                text = text.replace(// فَاشْتِغَالِي
                    new RegExp(escapeRegExp(`${madd}${letter}{sukun}`), "g"),
                    `${Object.values(currentType.harakaats)[index].marker}${letter}{sukun}`
                );
                text = text.replace(// وَادِّكَارِي
                    new RegExp(escapeRegExp(`${madd}${letter}${letter}`), "g"),
                    `${Object.values(currentType.harakaats)[index].marker}${letter}${letter}`
                );
            })

        });
        // ===== Quelques arrangements pour la lisiblite =====
        [
            {marker : "{ba}{i}{alif}{lam}{sukun}", value : "{ba}{i}{lam} "}, // bil
            {marker : "{waw}{a}{alif}{lam}{sukun}", value : "{waw}{a}{lam} "}, // wal
            {marker : "{waw}{aa}{lam}{sukun}", value : "{waw}{a}{lam} "}, //wal
            {marker : "{waw}{a}{lam}{sukun}", value : "{waw}{a}{lam} "}, //wal
        ].forEach(({marker,value}) => {
            text = text.replace(new RegExp(escapeRegExp(marker),"g"),`${value}`)
        })
        Object.values(currentType.no_duplicables).forEach(({marker})=> { // no duplicables
            text = text.replace(new RegExp(escapeRegExp(`${marker}${marker}`),"g"),`${marker}`)
        })

        // ===== Transcription finale =====

        text = retireMarkers(text, all_letters);

        text = text.replace(/\n-/g, "\n");
        text = text.replaceAll(" -", " ");
        // text = text.replace(/\s\-/g, " ");

        return text
    }
    const transcrire = (arabicText) => {
        let text = addMarkers(arabicText, TRANSCRIPTION_TYPES.SIMPLE);
        text = treateTranscriptions(text, TRANSCRIPTION_TYPES.SIMPLE);
        setResultTextSimple(text.trim());


        text = addMarkers(arabicText, TRANSCRIPTION_TYPES.COMPLET);
        text = treateTranscriptions(text, TRANSCRIPTION_TYPES.COMPLET);
        setResultTextComplet(text.trim());
    }
    const save = () => {
        localStorage.setItem("inputText", inputText);
        localStorage.setItem("resultTextSimple", resultTextSimple);
        localStorage.setItem("resultTextComplet", resultTextComplet);
        alert('saving success')
    }
    const restore = (arabicText) => {
        setInputText(localStorage.getItem('inputText'));
        setResultTextSimple(localStorage.getItem('resultTextSimple'));
        setResultTextComplet(localStorage.getItem('resultTextComplet'));
        alert('restore success')
    }

    return (
        <div className='transcriptor row p-0 m-0'>
            <div className='top d-flex row'>
                <div className='col d-flex justify-content-center mt-4'>
                    <p className='mx-3 fs-5 text-white'>Type de Transcription :</p>
                    {
                        Object.entries(TRANSCRIPTION_TYPES).map(([k,v])=> {
                            return (
                                <div key={k} class="form-check">
                                    <label className="form-check-label text-white mx-3 fs-5">
                                        <input 
                                            type="radio" 
                                            name="flexRadioDefault" 
                                            className="form-check-input"
                                            value={true}
                                            onChange={()=> {
                                                setCurrentType(v)
                                            }}
                                        />
                                        {v.name}
                                    </label>
                                </div>
                            )
                        })
                    }
                </div>
                <div className='col d-flex justify-content-start align-items-start'>
                    <button 
                        className='btn btn-light m-auto'
                        onClick={()=>transcrire(inputText)}
                    >
                        Transcrire
                    </button>
                </div>
                <div className='col pt-4 text-end'>
                    <button 
                        className='btn btn-info m-auto me-4'
                        onClick={save}
                    >
                        Sauvgarder
                    </button>
                    <button 
                        className='btn btn-warning m-auto'
                        onClick={restore}
                    >
                        Restaurer
                    </button>
                </div>
            </div>
            <div className='bottom row p-0 m-0'>
                <div className='col right-side p-0 m-0'>
                    <textarea 
                        className='text-output'
                        value={resultTextComplet}
                        onChange={e => setResultTextComplet(e.target.value)}
                    ></textarea>
                </div>
                <div className='col right-side p-0 m-0'>
                    <textarea 
                        className='text-output'
                        value={resultTextSimple}
                        onChange={e => setResultTextSimple(e.target.value)}
                    ></textarea>
                </div>
                <div className='col right-side p-0 m-0'>
                    <textarea 
                        className='text-inupt'
                        value={inputText}
                        onChange={e => setInputText(e.target.value)}
                    ></textarea>
                </div>
            </div>
        </div>
    );
};

export default Transcriptor;